export type Lang = 'es' | 'en'

export interface Localized {
  es: string
  en: string
}

export function pick(value: Localized, lang: Lang): string {
  return value[lang]
}
